import React from 'react';
import PropTypes from 'prop-types';
import './ScoreWidget.css'

export default class ScoreWidget extends React.Component {

	constructor(props) {
		super(props);

		let p = parseInt(props.puntaje)
		if (!Number.isInteger(p)) {
			p = -1
		}

		this.state = {
			score: parseInt(props.score),
			puntaje: (0 == p) ? 1 : p, // El nivel 0 lo considero igual que el 1
		};
	}

	render() {
		if (-1 == this.state.puntaje) {
			return (<div></div>);
		}

		return (
			<div className={"scoreWidget"}>
				<div className={"puntajes"}>
					<span className={"p1"} />
					<span className={"p2"} />
					<span className={"p3"} />
					<span className={"p4"} />
					<span className={"p5"} />
				</div>
				<div
					className={"speech-bubble"}
					data-value={this.state.puntaje}>
					<i>{this.state.score}</i>
				</div>
			</div>
		);
	}
}

ScoreWidget.propTypes = {
	score: PropTypes.any,
	puntaje: PropTypes.any,
};



// WEBPACK FOOTER //
// ./src/scenes/personas/components/personas-detalle/components/ScoreWidget.js